document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-related-items-api]');

  sections.forEach((section) => {
    initRelatedItems(section).catch((error) => {
      console.error('Related items error:', error);
      showEmpty(section);
    });
  });
});

async function initRelatedItems(section) {
  const token = section.dataset.storefrontToken;
  const currentHandle = section.dataset.currentHandle;
  const currentPrice = Number(section.dataset.currentPrice || 0);
  const limit = Number(section.dataset.limit || 8);
  const jsonId = section.dataset.jsonId;

  const dataScript = document.getElementById(jsonId);
  if (!dataScript) {
    showEmpty(section);
    return;
  }

  const currentTags = JSON.parse(dataScript.textContent || '[]');

  const commonItemTags = [
    'シューズ',
    'ショルダーバッグ',
    'トートバッグ',
    'ボストンバッグ',
    'ハンドバッグ',
    'セカンドバッグ クラッチバッグ',
    'ビジネスバッグ ブリーフケース',
    'スーツケース トランク',
    'ウエストバッグ',
    'ボディバッグ',
    'リュック バックパック',
    'ポーチ',
    '腕時計',
    '懐中時計',
    'キーケース',
    'キーホルダー',
    'キーリング',
    'カードケース',
    'コインケース',
    '文房具',
    '長財布（小銭入れあり）',
    '長財布（小銭入れなし）',
    '二つ折り財布（小銭入れあり）',
    '二つ折り財布（小銭入れなし）',
    '三つ折り財布（小銭入れあり）',
    '三つ折り財布（小銭入れなし）',
    'ベルト',
    'マフラー',
    'スカーフ',
    'ストール',
    'ネクタイ',
    'カフス',
    'タイピン',
    '帽子',
    'サングラス',
    '眼鏡',
    'グローブ',
    'リング 指輪',
    'ブレスレット',
    'ブローチ',
    'ピアス',
    'イヤリング',
    'ネックレス',
    'ペンダントトップ',
    'チャーム',
    'チョーカー',
    'バングル',
    'ヘアアクセサリー',
    'ウォレットチェーン',
    'スーツ セットアップ',
    'ジャケット',
    'ワンピース',
    'コート',
    'トップス',
    'スカート',
    'ボトムス',
    'ベスト',
    'オーバーオール オールインワン',
    'ポンチョ ケープ',
    '食器',
    'その他',
    'ライター'
  ];

  const genderTags = ['メンズ', 'レディース', 'キッズ'];

  const brandTag = currentTags.find(
    (tag) => tag.startsWith('brand_') && !tag.startsWith('brand_ja_')
  ) || '';

  let itemTag =
    currentTags.find((tag) => tag.startsWith('item_'))?.replace('item_', '') || '';

  if (!itemTag) {
    itemTag = currentTags.find((tag) => commonItemTags.includes(tag)) || '';
  }

  const genderTag = currentTags.find((tag) => genderTags.includes(tag)) || '';

  const selected = [];
  const usedHandles = new Set([currentHandle]);

  // 1. 同じブランド + 同じアイテム + 同じ性別
  if (brandTag && itemTag && genderTag) {
    const primaryQuery = [
      `tag:'${escapeSearchValue(brandTag)}'`,
      `tag:'${escapeSearchValue(itemTag)}'`,
      `tag:'${escapeSearchValue(genderTag)}'`
    ].join(' AND ');

    const primaryProducts = await fetchProducts(token, primaryQuery, 24);
    addProducts(selected, usedHandles, primaryProducts, currentHandle, limit);
  }

  // 2. 同じブランド + 同じ性別
  if (selected.length < limit && brandTag && genderTag) {
    const brandGenderQuery = [
      `tag:'${escapeSearchValue(brandTag)}'`,
      `tag:'${escapeSearchValue(genderTag)}'`
    ].join(' AND ');

    const brandGenderProducts = await fetchProducts(token, brandGenderQuery, 32);
    addProducts(selected, usedHandles, brandGenderProducts, currentHandle, limit);
  }

  // 3. 同じアイテム + 近い価格帯 + 同じ性別
  if (selected.length < limit && itemTag && genderTag) {
    const itemGenderQuery = [
      `tag:'${escapeSearchValue(itemTag)}'`,
      `tag:'${escapeSearchValue(genderTag)}'`
    ].join(' AND ');

    const itemGenderProducts = await fetchProducts(token, itemGenderQuery, 50);
    addProductsByPrice(selected, usedHandles, itemGenderProducts, currentHandle, currentPrice, limit);
  }

  if (selected.length === 0) {
    showEmpty(section);
    return;
  }

  renderProducts(section, selected.slice(0, limit));
}

function escapeSearchValue(value) {
  return String(value).replace(/\\/g, '\\\\').replace(/'/g, "\\'");
}

async function fetchProducts(token, query, first = 24) {
  const endpoint = `${window.location.origin}/api/2026-04/graphql.json`;

  const gql = `
    query RelatedProducts($first: Int!, $query: String!) {
      products(first: $first, query: $query) {
        nodes {
          id
          handle
          title
          vendor
          tags
          onlineStoreUrl
          availableForSale
          featuredImage {
            url
            altText
          }
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
        }
      }
    }
  `;

  const res = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': token
    },
    body: JSON.stringify({
      query: gql,
      variables: {
        first,
        query
      }
    })
  });

  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }

  const json = await res.json();

  if (json.errors) {
    throw new Error(JSON.stringify(json.errors));
  }

  return json?.data?.products?.nodes || [];
}

function addProducts(selected, usedHandles, products, currentHandle, limit) {
  products.forEach((product) => {
    if (selected.length >= limit) return;
    if (!product) return;
    if (!product.handle || product.handle === currentHandle) return;
    if (usedHandles.has(product.handle)) return;

    usedHandles.add(product.handle);
    selected.push(product);
  });
}

function addProductsByPrice(selected, usedHandles, products, currentHandle, currentPrice, limit) {
  const filtered = products.filter((product) => {
    if (!product) return false;
    if (!product.handle || product.handle === currentHandle) return false;
    if (usedHandles.has(product.handle)) return false;
    return true;
  });

  filtered.sort((a, b) => {
    const aPrice = getProductPrice(a);
    const bPrice = getProductPrice(b);
    const aDiff = Math.abs(aPrice - currentPrice);
    const bDiff = Math.abs(bPrice - currentPrice);
    return aDiff - bDiff;
  });

  filtered.forEach((product) => {
    if (selected.length >= limit) return;
    usedHandles.add(product.handle);
    selected.push(product);
  });
}

function getProductPrice(product) {
  const amount = product?.priceRange?.minVariantPrice?.amount;
  return Number(amount || 0);
}

function getBrandName(product) {
  if (product.tags && Array.isArray(product.tags)) {
    const brandTag = product.tags.find(
      (tag) => tag.startsWith('brand_') && !tag.startsWith('brand_ja_')
    );

    if (brandTag) {
      return brandTag.replace('brand_', '');
    }
  }

  return product.vendor || '';
}

function renderProducts(section, products) {
  const loading = section.querySelector('.same-vendor-products__loading');
  const list = section.querySelector('.same-vendor-products__list');
  const empty = section.querySelector('.same-vendor-products__empty');

  if (loading) loading.classList.add('hidden');
  if (empty) empty.classList.add('hidden');
  if (!list) return;

  list.innerHTML = products.map((product) => {
    const brandName = getBrandName(product);

    const imageHtml = product.featuredImage
      ? `
        <div class="same-vendor-products-card__media">
          <img
            src="${escapeHtml(product.featuredImage.url)}"
            alt="${escapeHtml(product.featuredImage.altText || product.title)}"
            loading="lazy"
          >
        </div>
      `
      : `
        <div class="same-vendor-products-card__media same-vendor-products-card__media--empty"></div>
      `;

    const money = formatMoney(
      product.priceRange?.minVariantPrice?.amount,
      product.priceRange?.minVariantPrice?.currencyCode
    );

    return `
      <li class="grid__item">
        <a href="${escapeHtml(product.onlineStoreUrl || `/products/${product.handle}`)}" class="same-vendor-products-card">
          ${imageHtml}
          <div class="same-vendor-products-card__body">
            ${brandName ? `<div class="same-vendor-products-card__brand">${escapeHtml(brandName)}</div>` : ''}
            <div class="same-vendor-products-card__title">${escapeHtml(product.title)}</div>
            <div class="same-vendor-products-card__price">${escapeHtml(money)}</div>
          </div>
        </a>
      </li>
    `;
  }).join('');
}

function showEmpty(section) {
  const loading = section.querySelector('.same-vendor-products__loading');
  const empty = section.querySelector('.same-vendor-products__empty');

  if (loading) loading.classList.add('hidden');
  if (empty) empty.classList.remove('hidden');
}

function formatMoney(amount, currencyCode) {
  const numeric = Number(amount || 0);
  const currency = currencyCode || 'JPY';

  try {
    return new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency
    }).format(numeric);
  } catch (e) {
    return `${numeric}`;
  }
}

function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}